import React, { Fragment, useCallback } from 'react'
import PropTypes from 'prop-types'


type FormattedMessageProps = React.HTMLAttributes<HTMLElement> & {
  en: string
  es?: string
  values?: ReactIntlMessageValues
  tag?: string
  tagId?: string
  innerRef?: React.Ref<HTMLElement>
  dataTestId?: string
}

const FormattedHTMLMessage: React.FunctionComponent<FormattedMessageProps> = (props, context) => {
  const { intlData: { intl, locale } } = context
  const { children, tag, tagId, en, es, values, dataTestId, innerRef, ...rest } = props

  const message = intl.formatHTMLMessage({ en, es }, values, locale)

  let node

  if (Array.isArray(message)) {
    const children = message.map((messageItem, index) => {
      if (typeof messageItem === 'string') {
        return <span key={index} dangerouslySetInnerHTML={{ __html: messageItem }} />
      }

      return <Fragment key={index}>{messageItem}</Fragment>
    })

    node = React.createElement(tag, {
      ...rest,
      id: tagId,
      ref: innerRef,
      'data-testid': dataTestId,
    }, children)
  }
  else {
    node = React.createElement(tag, {
      ...rest,
      id: tagId,
      ref: innerRef,
      dangerouslySetInnerHTML: { __html: message },
      'data-testid': dataTestId,
    })
  }

  if (typeof children === 'function') {
    return children(node)
  }

  return node
}

FormattedHTMLMessage.contextTypes = {
  intlData: PropTypes.object,
}

FormattedHTMLMessage.defaultProps = {
  tag: 'span',
}


export default React.memo(FormattedHTMLMessage)
